var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bfebff;}.cls-2{fill:#febe10;}.cls-3{fill:#fffbc5;}.cls-4{fill:#4d4d4d;}.cls-5{fill:#71c2ea;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_209",
    "data-name": "Layer 209"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M545.5,104.83V549.17a50.34,50.34,0,0,1-50.33,50.33H50.83A50.34,50.34,0,0,1,.5,549.17V240.36L186.36,54.5H495.17A50.34,50.34,0,0,1,545.5,104.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pen"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.38,405.06l-93-92.76L499.65,7.76a22.62,22.62,0,0,1,31.94,0l61.06,60.92a22.5,22.5,0,0,1,0,31.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288.38,372l-32.25,1.92h0l1.9-32.09-32.16,1.91-.28-.29,1.91-32.13-32.2,1.91-.15-.15,0,.16H195l.07.07L171,403.17a35.6,35.6,0,0,1,25.49,25.43l90.32-24.15-.29-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.44,428.6l-34.82,9.31L171,403.17A35.6,35.6,0,0,1,196.44,428.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M185,55V189.33A49.67,49.67,0,0,1,135.33,239H1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditItem);
export default __webpack_public_path__ + "static/media/edit_item.45fa092ddf2335313dd835dfe9e1944e.svg";
export { ForwardRef as ReactComponent };